import { render, staticRenderFns } from "./PolicyReissueSuccessDialog.vue?vue&type=template&id=61f2f9aa&scoped=true&"
import script from "./PolicyReissueSuccessDialog.vue?vue&type=script&lang=js&"
export * from "./PolicyReissueSuccessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f2f9aa",
  null
  
)

export default component.exports